export default {
    'critical_finding_acknowledged': 'Critical finding acknowledged',
    'x_was_told': '{told} was told',
    'could_not_record_the_acknowledgement': 'Could not record the acknowledgement',
    'acknowledge_critical_finding': 'Acknowledge critical finding',
    'cancel': 'Cancel',
    'record_acknowledgement': 'Record acknowledgement',
    'record_who_received_the_critical_finding_and': 'Record who received the critical finding and what they read back. This is kept on the study permanently.',
    'who_was_told': 'Who was told',
    'name_and_role_of_the_person_you_told_x_x': 'Name and role of the person you told, {TOLD_MIN}-{TOLD_MAX} characters',
    'e_g_dr_ahmed_ward_4': 'e.g. Dr. Ahmed, ward 4',
    'read_back_note': 'Read-back note',
    'what_they_repeated_back_to_you_x_x_characters': 'What they repeated back to you, {NOTE_MIN}-{NOTE_MAX} characters',
    'sent_back_to_be_imaged_again': 'Sent back to be imaged again',
    'could_not_ask_for_a_retake': 'Could not ask for a retake',
    'addendum_verified': 'Addendum verified',
    'could_not_verify_the_addendum': 'Could not verify the addendum',
    'sending_waiting_images_to_the_online_copy_now': 'Sending waiting images to the online copy now',
    'could_not_send_now': 'Could not send now',
    'could_not_update_the_study': 'Could not update the study',
    'report_released': 'Report released',
    'the_patient_has_been_notified': 'The patient has been notified',
    'a_different_radiologist_must_verify_this_report': 'A different radiologist must verify this report',
    'your_hospital_does_not_let_the_person_who_wrote': 'Your hospital does not let the person who wrote a report verify it. Ask another radiologist to verify and release it.',
    'could_not_release_the_report': 'Could not release the report',
    'could_not_print_the_report': 'Could not print the report',
    'radiology': 'Radiology',
    'modality_worklist_reporting_and_release': 'Modality worklist, reporting and release',
    'send_images_now': 'Send images now',
    'all_modalities': 'All modalities',
    'modality': 'Modality',
    'order_study': 'Order study',
    'all_studies': 'All studies',
    'to_report': 'To report',
    'to_verify': 'To verify',
    'released': 'Released',
    'second_opinions': 'Second opinions',
    'setup': 'Setup',
    'could_not_open_the_study': 'Could not open the study',
    'search_studies': 'Search studies',
    'name_mrn_study_no_phone_cnic': 'Name, MRN, study no., phone, CNIC',
    'referring_doctor': 'Referring doctor',
    'nothing_in_this_stage': 'Nothing in this stage.',
    'patient': 'Patient',
    'study': 'Study',
    'referred_by': 'Referred by',
    'accession': 'Accession',
    'ordered': 'Ordered',
    'status': 'Status',
    'critical': 'Critical',
    'retake': 'Retake',
    'addendum_to_verify': 'Addendum to verify',
    'awaiting_payment': 'Awaiting payment',
    'arrived': 'Arrived',
    'scan_done': 'Scan done',
    'acknowledge': 'Acknowledge',
    'view_report': 'View report',
    'verify_and_release': 'Verify & release',
    'verify_addendum': 'Verify addendum',
    'second_opinion': 'Second opinion',
    'images': 'Images',
    'print_report': 'Print report',
    'print': 'Print',
    'load_more': 'Load more',
    'retake_x': 'Retake {name}',
    'x_x_the_study_goes_back_to_the_technician_the': '{fullName} · {number}. The study goes back to the technician; the draft report is kept as a version.',
    'why_is_it_being_imaged_again': 'Why is it being imaged again?',
    'ask_for_a_retake': 'Ask for a retake',
    'release_a_report_that_is_not_settled': 'Release a report that is not settled',
    'reason_for_releasing_anyway': 'Reason for releasing anyway',
    'release_with_reason': 'Release with reason',
    'study_ordered': 'Study ordered',
    'x_study_ies_added_to_the_worklist': '{length} study(ies) added to the worklist',
    'could_not_place_the_order': 'Could not place the order',
    'order_imaging': 'Order imaging',
    'place_order': 'Place order ·',
    'study_2': 'study',
    'priority': 'Priority',
    'search_by_name_code_or_modality': 'Search by name, code or modality',
    'e_g_chest_x_ray_ct_head': 'e.g. chest X-ray, CT head',
    'remove_x': 'Remove {name}',
    'clinical_notes': 'Clinical notes',
    'bill_these_studies_on_one_invoice': 'Bill these studies on one invoice',
    'off_each_study_gets_its_own_invoice': 'Off: each study gets its own invoice.',
    'pregnancy_status_has_been_checked': 'Pregnancy status has been checked',
    'required_before_any_study_involving_ionising': 'Required before any study involving ionising radiation can be ordered.',
    'addendum_filed': 'Addendum filed',
    'it_sits_under_the_original_report_with_your': 'It sits under the original report with your name and the time',
    'report_saved': 'Report saved',
    'a_consultant_must_verify_it_before_release': 'A consultant must verify it before release',
    'critical_finding_flagged': 'Critical finding flagged',
    'it_stays_flagged_until_someone_records_who_was': 'It stays flagged until someone records who was told',
    'could_not_file_the_addendum': 'Could not file the addendum',
    'could_not_save_the_report': 'Could not save the report',
    'close': 'Close',
    'file_addendum': 'File addendum',
    'save_report': 'Save report',
    'loading_the_study': 'Loading the study…',
    'the_study_could_not_be_loaded': 'The study could not be loaded',
    'try_again': 'Try again',
    'critical_finding_awaiting_acknowledgement': 'Critical finding - awaiting acknowledgement',
    'this_study_carries_a_critical_finding': 'This study carries a critical finding.',
    'clinical_history': 'Clinical history:',
    'prior': 'Prior',
    'studies': 'studies',
    'no_impression_recorded': 'no impression recorded',
    'findings': 'Findings',
    'impression': 'Impression',
    'recommendation': 'Recommendation',
    'no_report_has_been_written_for_this_study_yet': 'No report has been written for this study yet.',
    'this_report_has_already_been': 'This report has already been',
    'so_the_original_is_locked_your_text_is_filed_as': ', so the original is locked. Your text is filed as Addendum',
    'under_your_name_and_the_current_time_the': 'under your name and the current time; the original report and its author never change.',
    'addendum_findings': 'Addendum findings',
    'critical_finding_notify_the_referring_doctor_now': 'Critical finding - notify the referring doctor now',
    'this_study_is_already_flagged_tick_it_again': 'This study is already flagged. Tick it again only for a new critical finding; it will need a fresh acknowledgement.',
    'raises_the_alert_and_keeps_the_study_flagged': 'Raises the alert and keeps the study flagged until someone records who was told.',
    'critical_finding_note': 'Critical finding note',
    'what_the_referring_doctor_must_be_told_up_to': 'What the referring doctor must be told, up to 500 characters',
    'second_opinion_asked_for': 'Second opinion asked for',
    'ask_for_a_second_opinion': 'Ask for a second opinion',
    'ask': 'Ask',
    'radiologist': 'Radiologist',
    'choose_a_colleague': 'Choose a colleague',
    'what_to_look_at': 'What to look at',
    'optional': 'Optional',
    'second_opinion_given': 'Second opinion given',
    'which_second_opinions': 'Which second opinions',
    'asked_of_me': 'Asked of me',
    'asked_by_me': 'Asked by me',
    'no_second_opinions': 'No second opinions.',
    'asked_by': 'Asked by',
    'asked_of': 'Asked of',
    'question_and_answer': 'Question and answer',
    'waiting': 'Waiting',
    'open': 'Open',
    'answer': 'Answer',
    'give_your_second_opinion': 'Give your second opinion',
    'send': 'Send',
    'your_opinion': 'Your opinion',
    'could_not_issue_a_new_key': 'Could not issue a new key',
    'could_not_change_the_agent': 'Could not change the agent',
    'radiology_settings_saved': 'Radiology settings saved',
    'could_not_save_the_settings': 'Could not save the settings',
    'verification': 'Verification',
    'the_radiologist_who_wrote_a_report_cannot': 'The radiologist who wrote a report cannot verify it',
    'same_as_the_laboratory': 'Same as the laboratory (',
    'on': 'on',
    'off': 'off',
    'on_2': 'On',
    'off_2': 'Off',
    'image_import_agents': 'Image import agents',
    'add_agent': 'Add agent',
    'no_import_agent_yet_add_one_for_each_modality': 'No import agent yet. Add one for each modality PC that exports images to a folder.',
    'agent': 'Agent',
    'last_image': 'Last image',
    'never': 'Never',
    'active': 'Active',
    'disabled': 'Disabled',
    'new_key': 'New key',
    'disable': 'Disable',
    'enable': 'Enable',
    'add_an_image_import_agent': 'Add an image import agent',
    'add': 'Add',
    'code': 'Code',
    'letters_digits_and': 'Letters, digits, - and _',
    'name': 'Name',
    'key_for_x': 'Key for {name}',
    'shown_once_put_it_in_the_agents_settings_on_the': 'Shown once. Put it in the agent\'s settings on the modality PC now.',
    'key_copied': 'Key copied',
    'copy': 'Copy',
    'done': 'Done',
    'image_attached': 'Image attached',
    'could_not_attach_the_image': 'Could not attach the image',
    'image_removed': 'Image removed',
    'could_not_remove_the_image': 'Could not remove the image',
    'images_x': 'Images — {number}',
    'uploading_x': 'Uploading {value}%',
    'add_an_image': 'Add an image',
    'the_report_is_released_images_are_kept_as_they': 'The report is released; images are kept as they were. File an addendum to change the study.',
    'images_arrive_here_from_the_radiology': 'Images arrive here from the radiology workstation\'s export folder (the import agent names each file after the accession number) or by hand from this dialog.',
    'loading_images': 'Loading images…',
    'no_images_attached_yet': 'No images attached yet.',
    'import_agent': 'import agent',
    'uploaded': 'uploaded',
    'remove': 'Remove',
    'report_on_record': 'Report on record',
};
//# sourceMappingURL=radiology.js.map